import { type UseQueryResult, useQuery } from 'react-query';
import { PlanTypeService, PsuAwardService } from '@wealthlane/api-services/wealthlane-award-service';

const useGetPlanType = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string | number;
    }>
  | undefined,
  unknown
> => {
  const planType = useQuery(
    ['getPlanType'],
    async () => {
      return await handleRequest(PlanTypeService.getApiAwardApiAppPlanTypePlanType());
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.displayName ?? '',
            value: item.id ?? '',
          };
        });
      },
    }
  );

  return planType;
};

export default useGetPlanType;
